import React, { useState, useEffect, useRef } from "react";
import "./ContactModal.css";

function PhoneInput({ value, onChange }) {
  const prefix = "+380";

  const handleChange = (e) => {
    let val = e.target.value;
    if (val.startsWith(prefix)) {
      val = prefix + val.slice(prefix.length).replace(/\D/g, "").slice(0, 9);
    } else {
      val = prefix + val.replace(/\D/g, "").slice(0, 9);
    }
    onChange(val);
  };

  const handleFocus = () => {
    if (!value) onChange(prefix);
  };

  const handleKeyDown = (e) => {
    if ((e.key === "Backspace" || e.key === "Delete") && e.target.selectionStart <= 4) {
      e.preventDefault();
    }
  };

  return (
    <input
      type="tel"
      value={value}
      onChange={handleChange}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
      placeholder="012345678"
      required
    />
  );
}

export default function ContactModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [phone, setPhone] = useState("+380");
  const autoTimer = useRef(null);

  const SESSION_DURATION = 60 * 60 * 1000; // 60 хвилин

  // Глобальна функція для відкриття попапу вручну
  useEffect(() => {
    window.openContactModal = () => {
      sessionStorage.setItem("popupOpenedManually", Date.now());
      setIsOpen(true);
    };

    // Перевіряємо, чи минув час сесії
    const checkSession = (key) => {
      const ts = sessionStorage.getItem(key);
      if (!ts) return false;
      return (Date.now() - parseInt(ts, 10)) < SESSION_DURATION;
    };

    const autoOpenedValid = checkSession("popupOpenedAuto");
    const manualOpenedValid = checkSession("popupOpenedManually");

    if (!autoOpenedValid && !manualOpenedValid) {
      autoTimer.current = setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem("popupOpenedAuto", Date.now());
      }, 20000); // 20 секунд
    }

    return () => {
      if (autoTimer.current) clearTimeout(autoTimer.current);
    };
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const form = e.target;
    const name = form.name.value.trim();
    const service = form.service.value;

    if (!name || !phone || !service || phone.length !== 13) {
      setError("Заповніть всі поля коректно (+380XXXXXXXXX)");
      setLoading(false);
      return;
    }


    try {
      // ---- ЗАМІНИ URL на свій PHP-сервер ----
      const response = await fetch("https://kreobud.com.ua/send-form-thehotlogistics.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, phone, service })
      });

      if (!response.ok) throw new Error("Помилка сервера");

      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError("Помилка відправки. Спробуйте пізніше");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" >
      <div className="modal">

        <a className="modal-close" onClick={() => setIsOpen(false)}>×</a>

        {!submitted ? (
          <>
            <h2>Замовити прорахунок</h2>

            <form onSubmit={submitHandler} noValidate>

              <label>Імʼя</label>
              <input type="text" name="name" placeholder="Ваше імʼя" required />

              <label>Телефон</label>
              <PhoneInput value={phone} onChange={setPhone} />

              <label>Послуга</label>
              <select name="service" required>
                <option value="">Оберіть...</option>
                <option value="Доставка">Доставка</option>
                <option value="Консультація">Консультація</option>
                <option value="Підтримка">Підтримка</option>
              </select>

              {error && <p className="error">{error}</p>}

              <button className="btnsubmit" type="submit" disabled={loading}>
                {loading ? "Відправка..." : "Відправити"}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2>Запит успішно надісланий!</h2>
            <p className="success-text">Доєднайтеся до нас у</p>
			<p className="popup-links">
			<a href="https://www.facebook.com/hotLogistics/" target="_blank">Facebook</a> 
			<a href="https://www.instagram.com/hot_logistics/?utm_medium=copy_link" target="_blank">Instagram</a>
		</p>
          </>
        )}

      </div>
    </div>
  );
}



